import media from './Media'
import textblock from './TextBlock'
import poll from './Poll'
import quote from './Quote'
import flipcard from './FlipCard'
import oembed from './oEmbed'
import personalityquiz from './PersonalityQuiz'
import trivia from './Trivia'
import logicquiz from './LogicQuiz'
import ctaform from './ctaForm'
import ctabutton from './ctaButton'

const modules = [
  {
    name: 'textblock',
    context: textblock
  },
  {
    name: 'poll',
    context: poll
  },
  {
    name: 'quote',
    context: quote
  },
  {
    name: 'flipcard',
    context: flipcard
  },
  {
    name: 'oembed',
    context: oembed
  },
  {
    name: 'media',
    context: media
  },
  {
    name: 'personalityquiz',
    context: personalityquiz
  },
  {
    name: 'trivia',
    context: trivia
  },
  {
    name: 'logicquiz',
    context: logicquiz
  },
  {
    name: 'ctaform',
    context: ctaform
  },
  {
    name: 'ctabutton',
    context: ctabutton
  }
]

export {
  modules
}
